import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      background: theme.colors.background,
      width: "100%",
      height: "100%",
    },
    "@media (min-width: 1565px)": {
      container: {
        height: "100vh",
      },
    },
    mainSectionParent: {
      display: "flex",
      flexDirection: "column",
    },
    greeting: {
      ...theme.fonts.h1,
      marginTop: "80px",
      marginLeft: "24px",
      color: theme.colors.textDefault,
    },
    tileSection: {
      marginTop: "80px",
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
      backgroundColor: theme.colors.background,
    },
    usernameSection: {
      display: "flex",
      flexDirection: "row",
      marginTop: 24,
      "& > span:last-child": {
        ...theme.fonts.p2,
        color: theme.colors.textSubtle,
        margin: 4,
      },
    },

    switchFirmStyle: {
      ...theme.fonts.caption,
      marginTop: 8,
      color: theme.colors.action,
      cursor: "pointer",
    },
    applicationSection: {
      display: "flex",
      flexDirection: "column",
    },
    noApplicationSection: {
      width: "100%",
      height: "125px",
      display: "flex",
      marginLeft: "24px",
      alignItems: "center",
      ...theme.fonts.p2,
    },
    loadingApplicationsSection: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      marginLeft: "24px",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
